import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ReactCountryFlag from 'react-country-flag';
import './CountrySelector.css';

const countries = [
  { code: 'US', name: 'United States', dialCode: '+1' },
  { code: 'IN', name: 'India', dialCode: '+91' },
  { code: 'GB', name: 'United Kingdom', dialCode: '+44' },
  { code: 'CA', name: 'Canada', dialCode: '+1' },
  { code: 'AU', name: 'Australia', dialCode: '+61' },
  { code: 'DE', name: 'Germany', dialCode: '+49' },
  { code: 'FR', name: 'France', dialCode: '+33' },
  { code: 'IT', name: 'Italy', dialCode: '+39' },
  { code: 'ES', name: 'Spain', dialCode: '+34' },
  { code: 'BR', name: 'Brazil', dialCode: '+55' },
  { code: 'JP', name: 'Japan', dialCode: '+81' },
  { code: 'CN', name: 'China', dialCode: '+86' },
  { code: 'KR', name: 'South Korea', dialCode: '+82' },
  { code: 'SG', name: 'Singapore', dialCode: '+65' },
  { code: 'AE', name: 'UAE', dialCode: '+971' },
  { code: 'SA', name: 'Saudi Arabia', dialCode: '+966' },
  { code: 'ZA', name: 'South Africa', dialCode: '+27' },
  { code: 'NG', name: 'Nigeria', dialCode: '+234' },
  { code: 'EG', name: 'Egypt', dialCode: '+20' },
  { code: 'MX', name: 'Mexico', dialCode: '+52' },
  { code: 'AR', name: 'Argentina', dialCode: '+54' },
  { code: 'RU', name: 'Russia', dialCode: '+7' },
  { code: 'TR', name: 'Turkey', dialCode: '+90' },
  { code: 'NL', name: 'Netherlands', dialCode: '+31' },
  { code: 'SE', name: 'Sweden', dialCode: '+46' },
  { code: 'NO', name: 'Norway', dialCode: '+47' },
  { code: 'DK', name: 'Denmark', dialCode: '+45' },
  { code: 'FI', name: 'Finland', dialCode: '+358' },
  { code: 'CH', name: 'Switzerland', dialCode: '+41' },
  { code: 'AT', name: 'Austria', dialCode: '+43' },
  { code: 'BE', name: 'Belgium', dialCode: '+32' },
  { code: 'PL', name: 'Poland', dialCode: '+48' },
  { code: 'CZ', name: 'Czech Republic', dialCode: '+420' },
  { code: 'HU', name: 'Hungary', dialCode: '+36' },
  { code: 'RO', name: 'Romania', dialCode: '+40' },
  { code: 'BG', name: 'Bulgaria', dialCode: '+359' },
  { code: 'GR', name: 'Greece', dialCode: '+30' },
  { code: 'PT', name: 'Portugal', dialCode: '+351' },
  { code: 'IE', name: 'Ireland', dialCode: '+353' },
  { code: 'NZ', name: 'New Zealand', dialCode: '+64' },
  { code: 'TH', name: 'Thailand', dialCode: '+66' },
  { code: 'MY', name: 'Malaysia', dialCode: '+60' },
  { code: 'ID', name: 'Indonesia', dialCode: '+62' },
  { code: 'PH', name: 'Philippines', dialCode: '+63' },
  { code: 'VN', name: 'Vietnam', dialCode: '+84' },
  { code: 'BD', name: 'Bangladesh', dialCode: '+880' },
  { code: 'PK', name: 'Pakistan', dialCode: '+92' },
  { code: 'LK', name: 'Sri Lanka', dialCode: '+94' },
  { code: 'NP', name: 'Nepal', dialCode: '+977' },
  { code: 'BT', name: 'Bhutan', dialCode: '+975' },
  { code: 'MV', name: 'Maldives', dialCode: '+960' },
  { code: 'AF', name: 'Afghanistan', dialCode: '+93' },
  { code: 'IR', name: 'Iran', dialCode: '+98' },
  { code: 'IQ', name: 'Iraq', dialCode: '+964' },
  { code: 'IL', name: 'Israel', dialCode: '+972' },
  { code: 'JO', name: 'Jordan', dialCode: '+962' },
  { code: 'LB', name: 'Lebanon', dialCode: '+961' },
  { code: 'KW', name: 'Kuwait', dialCode: '+965' },
  { code: 'QA', name: 'Qatar', dialCode: '+974' },
  { code: 'BH', name: 'Bahrain', dialCode: '+973' },
  { code: 'OM', name: 'Oman', dialCode: '+968' },
  { code: 'YE', name: 'Yemen', dialCode: '+967' },
  { code: 'SY', name: 'Syria', dialCode: '+963' },
  { code: 'CY', name: 'Cyprus', dialCode: '+357' },
  { code: 'MT', name: 'Malta', dialCode: '+356' },
  { code: 'IS', name: 'Iceland', dialCode: '+354' },
  { code: 'LU', name: 'Luxembourg', dialCode: '+352' },
  { code: 'LI', name: 'Liechtenstein', dialCode: '+423' },
  { code: 'MC', name: 'Monaco', dialCode: '+377' },
  { code: 'SM', name: 'San Marino', dialCode: '+378' },
  { code: 'VA', name: 'Vatican City', dialCode: '+379' },
  { code: 'AD', name: 'Andorra', dialCode: '+376' },
  { code: 'BY', name: 'Belarus', dialCode: '+375' },
  { code: 'UA', name: 'Ukraine', dialCode: '+380' },
  { code: 'MD', name: 'Moldova', dialCode: '+373' },
  { code: 'LT', name: 'Lithuania', dialCode: '+370' },
  { code: 'LV', name: 'Latvia', dialCode: '+371' },
  { code: 'EE', name: 'Estonia', dialCode: '+372' },
  { code: 'SI', name: 'Slovenia', dialCode: '+386' },
  { code: 'SK', name: 'Slovakia', dialCode: '+421' },
  { code: 'HR', name: 'Croatia', dialCode: '+385' },
  { code: 'BA', name: 'Bosnia and Herzegovina', dialCode: '+387' },
  { code: 'RS', name: 'Serbia', dialCode: '+381' },
  { code: 'ME', name: 'Montenegro', dialCode: '+382' },
  { code: 'MK', name: 'North Macedonia', dialCode: '+389' },
  { code: 'AL', name: 'Albania', dialCode: '+355' },
  { code: 'XK', name: 'Kosovo', dialCode: '+383' },
  { code: 'MT', name: 'Malta', dialCode: '+356' }
];

const CountrySelector = ({ selectedCountry, onCountryChange, className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  const filteredCountries = countries.filter(country =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    country.dialCode.includes(searchTerm) ||
    country.code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleCountrySelect = (country) => {
    onCountryChange(country);
    setIsOpen(false);
    setSearchTerm('');
  };

  return (
    <div className={`country-selector ${className}`} ref={dropdownRef}>
      <button
        type="button"
        className="country-selector-button"
        onClick={() => setIsOpen(!isOpen)}
      >
        <ReactCountryFlag
          countryCode={selectedCountry.code}
          svg
          style={{
            width: '20px',
            height: '15px',
            marginRight: '8px'
          }}
        />
        <span className="dial-code">{selectedCountry.dialCode}</span>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="dropdown-arrow"
        >
          ▼
        </motion.div>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            className="country-dropdown"
          >
            <div className="search-container">
              <input
                type="text"
                placeholder="Search countries..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="country-search"
                autoFocus
              />
            </div>
            <div className="country-list">
              {filteredCountries.map((country) => (
                <motion.button
                  key={country.code}
                  type="button"
                  className={`country-option ${selectedCountry.code === country.code ? 'selected' : ''}`}
                  onClick={() => handleCountrySelect(country)}
                  whileHover={{ 
                    backgroundColor: 'rgba(139, 92, 246, 0.1)',
                    scale: 1.02
                  }}
                  whileTap={{ scale: 0.98 }}
                  transition={{ duration: 0.2 }}
                >
                  <ReactCountryFlag
                    countryCode={country.code}
                    svg
                    style={{
                      width: '20px',
                      height: '15px',
                      marginRight: '12px'
                    }}
                  />
                  <span className="country-name">{country.name}</span>
                  <span className="country-dial-code">{country.dialCode}</span>
                </motion.button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CountrySelector;
